<template>
  <div class="greeter">
    <div class="greeter-box" :class="{ left: position === 'LEFT' }">
      <div
          tabindex="0"
          role="button"
          style="position: absolute; width: 100%; margin-top: -20px; flex-shrink: 0"
          @click="$emit('greetingClicked')"
          @keydown.enter="$emit('greetingClicked')"
          @keydown.space="$emit('greetingClicked')"
      >
        <div style="display: flex; justify-content: center">
          <template v-if="from.fromType === 'random' && randomUserFromTeam">
            <div
                v-for="avatar in randomUserFromTeam.avatars"
                :key="avatar.abbr"
                class="circle avatar mr-1"
                style="display: inline-block; width: 40px; height: 40px; line-height: 1"
            >
              <img v-if="avatar.image" :src="avatar.image" alt="avatar" style="width: 40px; height: 40px" />

              <span
                  v-else
                  class="circle text-white"
                  style="
                  line-height: 42px;
                  width: 40px;
                  border-radius: 14px;
                  height: 40px;
                  text-align: center;
                  display: inline-block;
                "
                  :style="{ 'background-color': avatar.color }"
              >
                {{ avatar.abbr.substring(0, 1) }}
              </span>
            </div>
          </template>

          <template v-else-if="from.fromType !== 'random' && from.avatars">
            <template v-for="avatar in from.avatars">
              <div
                  v-if="from.avatars.length !== 2"
                  :key="avatar.abbr"
                  class="circle avatar mr-1"
                  style="display: inline-block; width: 40px; height: 40px; line-height: 1"
              >
                <img v-if="avatar.image" :src="avatar.image" style="width: 40px; height: 40px" />

                <span
                    v-else
                    class="circle text-white"
                    style="line-height: 42px; width: 40px; height: 40px; text-align: center; display: inline-block"
                    :style="{ 'background-color': avatar.color }"
                >
                  {{ avatar.abbr.substring(0, 1) }}
                </span>
              </div>

              <div
                  v-else
                  :key="avatar.abbr"
                  class="circle avatar mr-1"
                  style="
                  display: inline-block;
                  width: 40px;
                  height: 40px;
                  line-height: 1;
                  margin-top: 0px !important;
                  margin-left: -9px !important;
                "
              >
                <img v-if="avatar.image" :src="avatar.image" style="width: 40px; height: 40px" />

                <span
                    v-else
                    class="circle text-white"
                    style="line-height: 42px; width: 40px; height: 40px; text-align: center; display: inline-block"
                    :style="{ 'background-color': avatar.color }"
                >
                  {{ avatar.abbr.substring(0, 1) }}
                </span>
              </div>
            </template>
          </template>
        </div>
      </div>

      <div class="box">
        <i
            class="material-icons close"
            tabindex="0"
            role="button"
            @click="$emit('hideGreeting')"
            @keydown.enter="$emit('hideGreeting')"
            @keydown.space="$emit('hideGreeting')"
        >
          keyboard_arrow_down
        </i>

        <div
            class="message"
            tabindex="0"
            role="button"
            @click="$emit('greetingClicked')"
            @keydown.enter="$emit('greetingClicked')"
            @keydown.space="$emit('greetingClicked')"
        >
          <div class="title" style="display: flex">
            <strong style="align-self: center" class="truncate">
              {{ from.fromType === 'random' ? randomUserFromTeam?.name : from.name }}
            </strong>
          </div>

          <p class="pt-2" v-html="getMessageHtml"></p>
        </div>
      </div>
    </div>

    <div
        v-if="!isMobile()"
        tabindex="0"
        role="textbox"
        class="box chat"
        :class="{ left: position === 'LEFT' }"
        style="border-radius: 18px; display: flex; margin-top: 20px; padding: 14px 0 14px 16px; cursor: text"
        @click="$emit('greetingClicked')"
        @keydown.enter="$emit('greetingClicked')"
        @keydown.space="$emit('greetingClicked')"
    >
      <span style="margin-top: 4px; flex-grow: 1">
        {{ widget_settings.translations.chat.write_a_reply }}
      </span>

      <i
          class="material-icons"
          tabindex="0"
          role="button"
          style="cursor: pointer; color: #b7b7b7; padding-right: 0.7rem"
          @keydown.enter="$emit('greetingClicked')"
          @keydown.space="$emit('greetingClicked')"
      >
        insert_emoticon
      </i>

      <i
          class="material-icons"
          tabindex="0"
          role="button"
          style="cursor: pointer; padding-right: 1rem"
          :style="{ color: color }"
          @keydown.enter="$emit('greetingClicked')"
          @keydown.space="$emit('greetingClicked')"
      >
        send
      </i>
    </div>
  </div>
</template>

<script type="text/babel">
import IsMobile from '../Util/IsMobile';

export default {
  props: {
    from: {
      type: Object,
      default: () => ({}),
    },

    message: {
      type: String,
      default: '',
    },

    widget_settings: {
      type: Object,
      default: () => ({}),
    },

    color: {
      type: String,
      default: '',
    },

    position: {
      type: String,
      default: '',
    },
  },

  computed: {
    randomUserFromTeam() {
      if (this.from.team) {
        return this.from.team[Math.floor(Math.random() * this.from.team.length)];
      }

      return null;
    },

    getMessageHtml() {
      return this.nl2br(this.htmlEntities(this.message || ''));
    },
  },

  methods: {
    isMobile() {
      return IsMobile.any();
    },

    nl2br(str = '') {
      return str.replace(/\n/g, '<br />');
    },

    htmlEntities(str = '') {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
  },
};
</script>
